/* Datei: src/pages/BlogAdmin/BlogManagement.js */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';
import './BlogManagement.css';

const BlogManagement = () => {
  const [blogEntries, setBlogEntries] = useState([]);

  useEffect(() => {
    fetchBlogEntries();
  }, []);

  const fetchBlogEntries = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/blog-entries`);
      setBlogEntries(response.data);
    } catch (error) {
      console.error('Error fetching blog entries:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Möchten Sie diesen Blog-Eintrag wirklich löschen?')) {
      try {
        await axios.delete(`${API_BASE_URL}/blog-entries/${id}`);
        fetchBlogEntries();
      } catch (error) {
        console.error('Error deleting blog entry:', error);
      }
    }
  };

  const handleToggleVisibility = async (entry) => {
    try {
      const updated = { ...entry, approved: !entry.approved };
      await axios.put(`${API_BASE_URL}/blog-entries/${entry.id}`, updated);
      fetchBlogEntries();
    } catch (error) {
      console.error('Error updating blog entry:', error);
    }
  };

  return (
    <div className="blog-management">
      <h2>Blog-Einträge verwalten</h2>
      <table className="blog-entries-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Titel</th>
            <th>Veröffentlicht am</th>
            <th>Status</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {blogEntries.map(entry => (
            <tr key={entry.id}>
              <td>{entry.id}</td>
              <td>{entry.title || "Ohne Titel"}</td>
              <td>{entry.created_at}</td>
              <td>{entry.approved ? "Sichtbar" : "Unsichtbar"}</td>
              <td>
                <button onClick={() => handleToggleVisibility(entry)}>
                  {entry.approved ? "Ausblenden" : "Einblenden"}
                </button>
                <button onClick={() => handleDelete(entry.id)}>
                  Löschen
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BlogManagement;
